import { useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import CategoryNav from "./components/CategoryNav";
import Featured from "./components/Featured";
import Feed from "./components/Feed";
import Trends from "./components/Trends";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import SeoJsonLd from "./components/SeoJsonLd";

const scrollToStream = () => {
  document.getElementById("stream")?.scrollIntoView({ behavior: "smooth" });
};

export default function Home() {
  const [search, setSearch] = useState("");
  const [cat, setCat] = useState("all");

  const openCategory = (id: string) => {
    setSearch("");
    setCat(id);
    scrollToStream();
  };

  const pickSearch = (word: string) => {
    setSearch(word);
    scrollToStream();
  };

  return (
    <div className="min-h-screen">
      <SeoJsonLd />
      <Header search={search} onSearchChange={setSearch} onSearchSubmit={scrollToStream} />
      <main>
        <Hero search={search} onSearchChange={setSearch} onSearchSubmit={scrollToStream} />
        <HotList onOpenCategory={openCategory} />
        <CategoryNav onOpenCategory={openCategory} />
        <Featured onOpenCategory={openCategory} />
        <Feed search={search} activeCat={cat} onSelectCat={setCat} />
        <Trends onPick={pickSearch} />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}